import { Injectable } from '@angular/core';
import { RuleValueService } from '../rule-value/rule-value.service';

export enum AdjustedProviderCommissionDeviationState {
  NONE = 'none',
  WARN = 'warn',
  BLOCK = 'block'
}

export class ProviderCommissionAdjustmentThresholds {
  warnDollars: number;
  warnPercent: number;
  blockDollars: number;
  blockPercent: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProviderCommissionAdjustmentValidationService {
  constructor(private ruleValueService: RuleValueService) {}

  getProviderCommissionAdjustmentThresholds(isWav: boolean): ProviderCommissionAdjustmentThresholds {
    if (isWav) {
      return {
        warnDollars: this.ruleValueService.getAdjustedWavProviderCommissionWarningThresholdTotalDefault(),
        warnPercent: this.ruleValueService.getAdjustedWavProviderCommissionWarningThresholdPercentageDefault(),
        blockDollars: this.ruleValueService.getAdjustedWavProviderCommissionBlockingThresholdTotalDefault(),
        blockPercent: this.ruleValueService.getAdjustedWavProviderCommissionBlockingThresholdPercentageDefault()
      };
    }

    return {
      warnDollars: this.ruleValueService.getAdjustedProviderCommissionWarningThresholdTotalDefault(),
      warnPercent: this.ruleValueService.getAdjustedProviderCommissionWarningThresholdPercentage(),
      blockDollars: this.ruleValueService.getAdjustedProviderCommissionBlockingThresholdTotalDefault(),
      blockPercent: this.ruleValueService.getAdjustedProviderCommissionBlockingThresholdPercentageDefault()
    };
  }

  getDeviationState(
    overageDollars: number,
    overagePercent: number,
    thresholds: ProviderCommissionAdjustmentThresholds
  ): AdjustedProviderCommissionDeviationState {
    if (overageDollars >= thresholds.blockDollars || overagePercent >= thresholds.blockPercent) {
      return AdjustedProviderCommissionDeviationState.BLOCK;
    }
    if (overageDollars >= thresholds.warnDollars || overagePercent >= thresholds.warnPercent) {
      return AdjustedProviderCommissionDeviationState.WARN;
    }
    return AdjustedProviderCommissionDeviationState.NONE;
  }
}
